export enum NodeType {
   NODE  = 0,
   LEAF = 1,
   NODE_ARRAY = 2,
   REPEAT_NODE = 128,
   REPEAT_LEAF = 129
}
